/**
 * Created by tofael on 3/23/17.
 */
import getMuiTheme from 'material-ui/styles/getMuiTheme';

const themeDefault = getMuiTheme({
  palette: {
  },
  appBar: {
    height: 57
  },
  drawer: {
    width: 230,
    color: '#1C2B36'
  },
  listItem: {
    secondaryTextColor:"#fafafa"
  },
  menuItem:{
    selectedTextColor:"#f0f8ff"
  }
});


export default themeDefault;


// WEBPACK FOOTER //
// ./src/utility/theme-default.js